/**
 * Tek para birimi biçimlendirici — booking akışlarında 5+ yerde tekrar eden
 * (`formatMoney` / `fareDisplayPrice` / `offerPrice` / satır-içi `toLocaleString('tr-TR')` /
 * `formatCurrency`) mantığın ortak yeri. tr-TR biçimi, `TRY` → "TL".
 */

/** `1936.74, 'TRY'` → `"1.936,74 TL"`. Tutar yoksa boş dize. */
export function formatMoney(amount?: number | null, currency?: string | null): string {
  if (amount == null) return '';
  const n = amount.toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  const cur = currency === 'TRY' ? 'TL' : currency;
  return cur ? `${n} ${cur}` : n;
}

/** Tam sayı/serbest gösterim — kuruş zorunlu değil (ör. bütçe etiketi). */
export function formatAmount(amount?: number | null): string {
  if (amount == null) return '';
  return amount.toLocaleString('tr-TR');
}
